<template lang="html">

</template>

<script>
export default {

  name: "KeyboardShortcuts",

  mounted () {
    // Use keydown for arrow keys (non-printable characters) and IE instead of keypress
    window.addEventListener('keydown', (e)=> {
      this.handleKeyDown(e)
    })
  },

  destroyed () {
    // Remove event listeners
    window.removeEventListener('keydown', (e)=> {
      this.handleKeyDown(e)
    })
  },

	methods: {

  	// Return true if there is no keyboard focus on buttons, inputs, links etc.
  	noFocus (e) {
  		const focussed = e.target.tagName.toLowerCase()

  		return (focussed === 'body') ? true
            :(focussed === 'html') ? true
            :(focussed === 'article') ? true // Because modal windows get focus on article
            :                        false
  	},
    // Event handlers for keyboard events.
    handleKeyDown (e) {
      const key = e.key

      // Modern browsers support e.key
      if (key) {

        // Esc
        if (key === 'Escape'){
          e.preventDefault()
          this.$emit('onEscapePress', e)
        }
        // Tab
        if (key === 'Tab'){
          this.$emit('onTabPress', e, e)
        }
        // Space bar
        if ((key === ' ' || key === 'Spacebar') && this.noFocus(e)){
          e.preventDefault()
          this.$emit('onSpaceBarPress', e)
        }
        // Plus
        else if (
          (key === '+' || key === '=') &&
          !e.ctrlKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('onPlusPress', e)
        }
        // Minus
        else if (
          (key === '_' || key === '-') &&
          !e.ctrlKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('onMinusPress', e)
        }
        // F
        else if (
          (key === 'f' || key === 'F') &&
          !e.ctrlKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('onfPress', e)
        }
        // r
        else if (
          (key === 'r' || key === 'R') &&
          !e.shiftKey &&
          !e.ctrlKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('onrPress', e)
        }
        else if (
          (key === 't' || key === 'T') &&
          !e.shiftKey &&
          !e.ctrlKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('ontPress', e)
        }
        // Shift+r
        else if (
          (key === 'r' || key === 'R') &&
          e.shiftKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('onShiftRPress', e)
        }
        // Arrow up
        else if ((key === 'ArrowUp' || key === 'Up') && this.noFocus(e)){
          e.preventDefault()
          this.$emit('onPlusPress', e)
        }
        // Arrow down
        else if ((key === 'ArrowDown' || key === 'Down') && this.noFocus(e)){
          e.preventDefault()
          this.$emit('onMinusPress', e)
        }
        // Left arrow
        else if ((key === 'ArrowLeft' || key === 'Left') && this.noFocus(e)){
          e.preventDefault()
          this.$emit('onPlusPress', e)
        }
        // Right arrow
        else if ((key === 'ArrowRight' || key === 'Right') && this.noFocus(e)){
          e.preventDefault()
          this.$emit('onMinusPress', e)
        }
        // Numbers
        else if (
          ( key === '0' ||
            key === '1' ||
            key === '2' ||
            key === '3' ||
            key === '4' ||
            key === '5' ||
            key === '6' ||
            key === '7' ||
            key === '8' ||
            key === '9'
          ) &&
          !e.shiftKey &&
          !e.ctrlKey &&
          !e.metaKey &&
          this.noFocus(e)
        ){
          e.preventDefault()
          this.$emit('onNumberPress', e, key)
        }
      }
      // Same logic with deprecated charCode
      else {
        const charCode = e.charCode

        // Esc
        if (charCode === 27){
          e.preventDefault()
          this.$emit('onEscapePress', e)
        }
        // Tab
        if (charCode === 0){
          e.preventDefault()
          this.$emit('onTabPress', e)
        }
        // Space bar
        if (charCode === 32) {
          e.preventDefault()
          this.$emit('onSpaceBarPress', e)
        }
        // Plus
        else if (charCode === 43) {
          e.preventDefault()
          this.$emit('onPlusPress', e)
        }
        // Minus
        else if (charCode === 95) {
          e.preventDefault()
          this.$emit('onMinusPress', e)
        }
        // Arrow down
        else if (keyCode === 70) {
          e.preventDefault()
          this.$emit('onfPress', e)
        }
        // r
        else if (charCode === 114) {
          if (!e.metaKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault()
            this.$emit('onrPress', e)
          }
        }
        // Shift+r
        else if (charCode === 114 && e.shiftKey) {
          e.preventDefault()
          this.$emit('onShiftRPress', e)
        }
        // Arrow left
        else if (keyCode === 37) {
          e.preventDefault()
          this.$emit('onPlusPress', e)
        }
        // Arrow up
        else if (keyCode === 38) {
          e.preventDefault()
          this.$emit('onPlusPress', e)
        }
        // Arrow right
        else if (keyCode === 39) {
          e.preventDefault()
          this.$emit('onMinusPress', e)
        }
        // Arrow down
        else if (keyCode === 40) {
          e.preventDefault()
          this.$emit('onMinusPress', e)
        }
        // Numbers
        else if (keyCode === 48 || keyCode === 96) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 0)
        }
        else if (keyCode === 49 || keyCode === 97) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 1)
        }
        else if (keyCode === 50 || keyCode === 98) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 2)
        }
        else if (keyCode === 51 || keyCode === 99) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 3)
        }
        else if (keyCode === 52 || keyCode === 100) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 4)
        }
        else if (keyCode === 53 || keyCode === 101) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 5)
        }
        else if (keyCode === 54 || keyCode === 102) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 6)
        }
        else if (keyCode === 48 || keyCode === 103) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 7)
        }
        else if (keyCode === 48 || keyCode === 104) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 8)
        }
        else if (keyCode === 48 || keyCode === 105) {
          e.preventDefault()
          this.$emit('onNumberPress', e, 9)
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/KeyboardShortcuts.vue